import { render } from "./EeiaGenerality.vue?vue&type=template&id=622e1eee&scoped=true"
import script from "./EeiaGenerality.vue?vue&type=script&lang=js"
export * from "./EeiaGenerality.vue?vue&type=script&lang=js"

import "./EeiaGenerality.vue?vue&type=style&index=0&id=622e1eee&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rightcom-spa/rightcom-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622e1eee"]])

export default __exports__